/** kkFileView 在线预览（http://1.95.118.218:8012） */
export const KKFILEVIEW_BASE = 'http://1.95.118.218:8012'

export function base64EncodeUrl(url: string): string {
  return btoa(unescape(encodeURIComponent(url)))
}

/** 单文件在线预览地址 */
export function buildKkFileViewPreviewUrl(fileUrl: string): string {
  const u = fileUrl.trim()
  if (!u) return ''
  return `${KKFILEVIEW_BASE}/onlinePreview?url=${encodeURIComponent(base64EncodeUrl(u))}`
}
